import { loadData, UserDataProvider } from "../../Core/UserDataProvider";
import { PageModel } from "./PageModel";


class HomePageModel extends PageModel {
    constructor(){
        super("Home")
    }
}

export { HomePageModel }